/**
 * ZH resource — 履约模块 (P4)。键与 `vi/resources/vanHanh.ts` 一一对应。
 */
export const vanHanh = {
  titles: {
    donHangList: '全部履约订单',
    tabDanhSach: '订单列表',
    tabGanNhanVien: '分配员工',
    xepNhat: '拣货',
    kiemTra: '验货',
    dongGoi: '打包',
    dieuPhoi: '调度',
    giaoHang: '配送',
    chiTietDon: '履约订单详情',
    thongBao: '通知中心',
  },
  fields: {
    xuLy: '处理',
    viTri: '位置',
    tieuDe: '标题',
    kichThuoc: '尺寸',
    maHoaDon: '发票号',
    khachHang: '客户',
    trangThai: '状态',
    trangThaiVanHanh: '履约状态',
    chiNhanh: '分店',
    khachCanTra: '应收金额',
    khachDaTra: '已收金额',
    conLai: '剩余',
    nguoiBan: '销售员',
    nguoiNhanHang: '收货人',
    nguoiNhat: '拣货员',
    nguoiPhanCong: '分配人',
    nguoiKiemTra: '验货员',
    nguoiDongGoi: '打包员',
    nguoiDieuPhoi: '调度员',
    nguoiShip: '配送员',
    thoiGian: '时间',
    thoiGianPhanCong: '分配时间',
    thoiGianBatDau: '开始时间',
    thoiGianHoanThanh: '完成时间',
    thoiGianNhan: '接收时间',
    soLuong: '数量',
    soLuongDaNhat: '已拣',
    soLuongDuKien: '预计',
    soLuongThucTe: '实际',
    chenhLech: '差异',
    tongSoKien: '总件数',
    thongTinKienChiTiet: '包裹明细',
    anhChungTu: '凭证照片',
    ghiChu: '备注',
    lyDo: '原因',
    maVanDon: '运单号',
    soLanIn: '打印次数',
    cotIn: '打印',
    nguonThayDoi: '变更来源',
    nguoiThucHien: '操作人',
    hanhDong: '操作',
    noiDung: '内容',
    watched: '已读',
    chuaDoc: '未读',
    phuongThucBanGiao: '交接方式',
    id: 'ID',
    giaoHangKiot: 'Kiot配送',
    trangThaiDon: '订单状态',
    maDonHang: '订单号',
    maKh: '客户编码',
    nhanVienBanHang: '销售员',
    sdtNhanVien: '员工电话',
    sslSp: '商品总数量',
    tongCan: '总重量',
    tongKhoi: '总体积',
    thoiCapNhat: '更新时间',
    xemSua: '查看 / 编辑',
    trangThaiGiaoHang: '运单状态',
    maKhachHang: '客户编码',
    tenKhachHang: '客户名称',
    ghiChuGiaoHang: '配送备注',
    soSanPham: '商品数',
    soLuongSanPham: '商品总数量',
    tongCanNang: '总重量',
    tongTheTich: '总体积',
    diaChiGiaoHang: '配送地址',
    hanGiaoHang: '交付期限',
    doUuTien: '优先级',
    tongTien: '总金额',
    ghiChuTrangThaiDon: '状态备注',
    thoiGianTao: '创建日期',
    thoiGianCapNhat: '更新日期',
    ngayDatHang: '下单日期',
    hangVanChuyen: '承运商',
    phanCong: '分配',
    maHangHoa: '商品编码',
    tenHangHoa: '商品名称',
    dienThoai: '电话',
    tenNguoiNhan: '收货人',
    sdtNguoiNhan: '收货人电话',
    tongTienHang: '商品总额',
    giamGia: '折扣',
  },
  filters: {
    thongTinDonSection: '订单信息',
    phamViSection: '仓库范围',
    phamViTatCa: '全部',
    phamViCuaToi: '仅我的',
    hintSection: '履约筛选',
    hintBody: '按环节状态与执行人筛选',
    search: '搜索发票号 / 客户名称',
    trangThai: '状态',
    nguoiThucHien: '执行人',
    loaiThongBao: '通知类型',
    chiNhanh: '分店',
    khoVatLy: '实体仓',
    khoVatLyTatCa: '全部实体仓',
    khoVatLyDaChon: '{count} 个实体仓',
    khoVatLyEmpty: '暂无实体仓',
    tuNgay: '开始日期',
    denNgay: '结束日期',
    tatCa: '全部',
    maHoaDon: '发票号',
    maKhachHang: '客户编码',
    tenKhachHang: '客户名称',
    maHangHoa: '商品编码',
    tenHangHoa: '商品名称',
    trangThaiGiaoHang: '运单状态',
    ngayDatHang: '下单日期',
    ngayTao: '创建日期',
    hanGiaoHang: '交付期限',
    nguoiBan: '销售员',
    nguoiNhat: '拣货员',
    nguoiKiemTra: '验货员',
    nguoiDongGoi: '打包员',
    nguoiDieuPhoi: '调度员',
    nguoiShip: '配送员',
    thoiGianSection: '日期',
    nhanVienSection: '员工',
    nhanVienHint: '按各环节执行人筛选',
  },
  placeholders: {
    search: '输入发票号或客户名称',
    lyDo: '输入原因',
    ghiChu: '输入备注',
    thongTinKienChiTiet: '如：箱1：5件上衣；箱2：3条裤子',
    chonNhanVien: '选择员工',
    maHoaDonMoi: '目标发票号/ID',
  },
  trangThaiVanHanh: {
    MOI: '新单',
    CHO_NHAT: '待拣货',
    DANG_NHAT: '拣货中',
    CHO_KIEM_TRA: '待验货',
    DANG_KIEM_TRA: '验货中',
    CHO_DONG_GOI: '待打包',
    DANG_DONG_GOI: '打包中',
    CHO_DIEU_PHOI: '待调度',
    DANG_DIEU_PHOI: '调度中',
    CHO_GIAO_HANG: '待配送',
    DANG_GIAO_HANG: '配送中',
    GIAO_MOT_PHAN: '部分配送',
    DA_GIAO_HANG: '已配送',
    GIAO_THAT_BAI: '配送失败',
    DANG_GIAO_LAI: '重新配送中',
    CHO_GIAO_LAI: '待重新配送',
    HUY_DON: '已取消',
  },
  // ===== 8 承运商配送状态 (DHGiaoHangHoaDon) =====
  trangThaiVanDon: {
    CHO_XU_LY: '待处理',
    CHO_LAY_HANG: '待取件',
    DANG_GIAO: '配送中',
    DA_GIAO: '已送达',
    PHAT_KHONG_THANH_CONG: '派送失败',
    DANG_TRA_HANG: '退回中',
    TRA_HANG: '已退回',
    HUY: '已取消',
  },
  trangThaiPhanCong: {
    DA_PHAN_CONG: '已分配',
    DANG_NHAT: '拣货中',
    HOAN_THANH: '已完成',
  },
  trangThaiKiemTra: {
    CHO_KIEM_TRA: '待验货',
    DANG_KIEM_TRA: '验货中',
    HOAN_THANH: '已完成',
  },
  trangThaiDongGoi: {
    CHO_DONG_GOI: '待打包',
    DANG_DONG_GOI: '打包中',
    HOAN_THANH: '已完成',
  },
  trangThaiDieuPhoi: {
    CHO_DIEU_PHOI: '待调度',
    DANG_DIEU_PHOI: '调度中',
    HOAN_THANH: '已完成',
  },
  trangThaiDonShip: {
    CHO_GIAO_HANG: '待配送',
    DANG_GIAO_HANG: '配送中',
    DA_GIAO_HANG: '已配送',
    GIAO_MOT_PHAN: '部分配送',
    GIAO_THAT_BAI: '配送失败',
    CHO_GIAO_LAI: '待重新配送',
    DANG_GIAO_LAI: '重新配送中',
  },
  trangThaiThanhToan: {
    CHUA_TT: '未付款',
    TT_MOT_PHAN: '部分付款',
    DA_TT: '已付款',
  },
  nguonThayDoi: {
    USER: '用户',
    SYSTEM_JOB: '系统',
    API: 'API',
  },
  phuongThucBanGiao: {
    MANUAL: '手动',
    AUTO_SUGGEST: '自动建议',
    QR_SCAN: '扫码',
  },
  loaiThongBao: {
    CODONHANGMOI: '新订单',
    CODONHANGCANNHAT: '待拣货',
    CODONHANGCANKIEMTRA: '待验货',
    CODONHANGCANDONGGOI: '待打包',
    CODONHANGCANDIEUPHOI: '待调度',
    CODONHANGCANGIAO: '待配送',
  },
  actions: {
    phanCongNhat: '分配拣货',
    xemChiTiet: '查看详情',
    taoPhanCong: '创建拣货分配',
    batDauNhat: '开始拣货',
    hoanThanhNhat: '完成拣货',
    capNhatSoLuongNhat: '更新拣货数量',
    thamGiaNhat: '加入拣货',
    xoaPhanCong: '删除分配',
    batDauKiemTra: '开始验货',
    luuKiemTra: '保存验货结果',
    hoanThanhKiemTra: '完成验货',
    xoaKiemTra: '删除验货单',
    batDauDongGoi: '开始打包',
    hoanThanhDongGoi: '完成打包',
    thamGiaDongGoi: '加入打包',
    taiAnh: '上传照片',
    xoaAnh: '删除照片',
    xoaDongGoi: '删除打包单',
    ganNguoiDieuPhoi: '分配调度员',
    batDauDieuPhoi: '开始调度',
    hoanThanhDieuPhoi: '完成调度',
    thamGiaDieuPhoi: '加入调度',
    xoaDieuPhoi: '删除调度单',
    batDauGiao: '开始配送',
    giaoThanhCong: '配送成功',
    giaoMotPhan: '部分配送',
    giaoThatBai: '配送失败',
    batDauGiaoLai: '开始重新配送',
    ganLaiNguoiShip: '改派配送员',
    thamGiaGiao: '加入配送',
    xoaDonShip: '删除配送单',
    resetDon: '重置订单',
    overrideTrangThai: '强制状态',
    chuyenDoiLienKet: '转移关联',
    inPhieuDongGoi: '打印打包单',
    inPhieuGiaoHang: '打印配送单',
    in: '打印',
    ganNhanVien: '分配员工',
    gan: '分配',
    xemLichSuNhat: '查看拣货记录',
    danhDauDaXem: '标记已读',
    xemTatCaDaXem: '全部标记已读',
    xoaThongBao: '删除通知',
    choPhepThongBao: '开启推送',
    lamMoi: '刷新',
  },
  messages: {
    loadError: '加载履约列表失败',
    batDauNhatThanhCong: '已开始拣货',
    hoanThanhNhatThanhCong: '拣货完成 — 已创建验货单',
    capNhatSoLuongThanhCong: '拣货数量已更新',
    taoPhanCongThanhCong: '已创建拣货分配',
    capNhatPhanCongThanhCong: '拣货分配已更新',
    xoaPhanCongThanhCong: '分配已删除 — 订单回到新单',
    thamGiaThanhCong: '加入成功',
    batDauKiemTraThanhCong: '已开始验货',
    luuKiemTraThanhCong: '验货结果已保存',
    hoanThanhKiemTraThanhCong: '验货完成 — 已创建打包单',
    xoaKiemTraThanhCong: '验货单已删除',
    batDauDongGoiThanhCong: '已开始打包',
    capNhatDongGoiThanhCong: '打包信息已更新',
    hoanThanhDongGoiThanhCong: '打包完成 — 已创建调度单',
    xoaDongGoiThanhCong: '打包单已删除',
    taiAnhThanhCong: '照片已上传',
    xoaAnhThanhCong: '照片已删除',
    ganNguoiThanhCong: '分配成功',
    batDauDieuPhoiThanhCong: '已开始调度',
    hoanThanhDieuPhoiThanhCong: '调度完成 — 已创建配送单',
    xoaDieuPhoiThanhCong: '调度单已删除',
    batDauGiaoThanhCong: '已开始配送',
    giaoThanhCongThanhCong: '已记录配送成功',
    giaoMotPhanThanhCong: '已记录部分配送',
    giaoThatBaiThanhCong: '已记录配送失败',
    giaoLaiThanhCong: '已开始重新配送',
    ganLaiShipThanhCong: '配送员已改派',
    xoaDonShipThanhCong: '配送单已删除',
    resetThanhCong: '订单已重置',
    overrideThanhCong: '状态已强制更新',
    chuyenDoiLienKetThanhCong: '关联已转移',
    danhDauDaXemThanhCong: '已标记为已读',
    xoaThongBaoThanhCong: '通知已删除',
    chuaCoDuLieu: '暂无数据',
    chuaCoDuLieuKhopLoc: '没有符合筛选条件的数据',
    canChonNhanVien: '请至少选择一名员工',
    canNhapLyDo: '请输入原因',
    canNhapSoKien: '请输入总件数',
    canNhapMaHoaDonMoi: '请输入目标发票',
    coWarnings: '操作完成但有警告',
  },
  xacNhan: {
    batDauNhat: '开始拣货订单 {maHoaDon}？',
    hoanThanhNhat: '完成订单 {maHoaDon} 的拣货？将创建验货单。',
    xoaPhanCong: '删除订单 {maHoaDon} 的拣货分配？订单将回到新单。',
    batDauKiemTra: '开始验货订单 {maHoaDon}？您将成为验货员。',
    hoanThanhKiemTra: '完成订单 {maHoaDon} 的验货？将创建打包单。',
    xoaKiemTra: '删除订单 {maHoaDon} 的验货单？订单将回到拣货中。',
    batDauDongGoi: '开始打包订单 {maHoaDon}？',
    hoanThanhDongGoi: '完成订单 {maHoaDon} 的打包？将创建调度单。',
    xoaDongGoi: '删除订单 {maHoaDon} 的打包单？订单将回到验货中。',
    batDauDieuPhoi: '开始调度订单 {maHoaDon}？',
    hoanThanhDieuPhoi: '完成订单 {maHoaDon} 的调度？将创建配送单。',
    xoaDieuPhoi: '删除订单 {maHoaDon} 的调度单？订单将回到打包中。',
    batDauGiao: '开始配送订单 {maHoaDon}？',
    giaoThanhCong: '确认订单 {maHoaDon} 配送成功？',
    giaoMotPhan: '确认订单 {maHoaDon} 部分配送？',
    giaoThatBai: '确认订单 {maHoaDon} 配送失败？',
    giaoLai: '开始重新配送订单 {maHoaDon}？',
    xoaDonShip: '删除订单 {maHoaDon} 的配送单？订单将回到待调度。',
    resetDon: '将订单 {maHoaDon} 重置为"{trangThai}"？',
    overrideTrangThai: '将订单 {maHoaDon} 状态强制改为"{trangThai}"？管理操作 — 用于数据异常。',
    chuyenDoiLienKet: '将订单 {maHoaDon} 的全部流程转移到目标订单？当前订单将被取消。',
    xoaThongBao: '删除此通知？',
    xoaAnh: '删除此照片？',
  },
  xepNhat: {
    chuaPhanCongTitle: '待分配拣货的发票',
    chuaPhanCongHint: '尚无拣货员的新流程订单',
    taoPhanCongTitle: '创建拣货分配',
    capNhatPhanCongTitle: '更新拣货分配',
    chonNguoiNhat: '拣货员',
    chonDongHang: '要拣货的行',
    tatCaDong: '全部行（默认）',
    lichSuNhatTitle: '拣货记录',
    sttLan: '次数',
    soLuongTangThem: '增加数量',
    daNhatDu: '足够',
    conThieu: '缺少 {so}',
    tieuDeForm: '拣货 — {maHoaDon}',
  },
  kiemTra: {
    tieuDeForm: '验货 — {maHoaDon}',
    hintDuKienVsThucTe: '输入每行实际数量 — 差异行将高亮',
    dongDu: '正常',
    dongThieu: '缺少 {so}',
    dongDuThua: '多出 {so}',
    nguoiKiemTraHint: '点击"开始验货"的人即为验货员',
  },
  dongGoi: {
    tieuDeForm: '打包 — {maHoaDon}',
    anhChungTuHint: '打包后的包裹照片（交接凭证）',
    phieuKhoLienKet: '关联库存单',
  },
  dieuPhoi: {
    tieuDeForm: '调度 — {maHoaDon}',
    phanNhanh: '分支',
    giaoNoiBo: '内部配送',
    banGiaoHang: '交接承运商',
    banGiaoHangHint: '承运商订单：完成调度即交接 — 运单在运输模块跟踪',
    nguoiShipKhiHoanThanh: '内部配送员（完成时）',
    chuaCoVanDon: '暂无运单号',
  },
  giaoHang: {
    tieuDeForm: '配送 — {maHoaDon}',
    ketQuaGiao: '配送结果',
    chiTietGiaoMotPhan: '已配送行明细',
    soLuongGiaoLanNay: '第几次',
    soLuongGiao: '配送数量',
    anhBangChung: '配送凭证照片',
    thongTinGhiNhan: '配送记录',
    canNguoiShip: '尚未分配配送员 — 请先分配再开始',
  },
  chiTiet: {
    timeline: '状态历史',
    buoc: '环节',
    buoc1: '拣货',
    buoc2: '验货',
    buoc3: '打包',
    buoc4: '调度',
    buoc5: '配送',
    chuaCoBuoc: '此环节暂无数据',
    qrBanGiao: '交接二维码',
    qrHint: '接收人扫码加入自己的环节',
    inPhieu: '打印单据',
    trangThaiCu: '原状态',
    trangThaiMoi: '新状态',
    thongTinHoaDon: '发票信息',
    thongTinKhachHang: '客户信息',
    thanhToan: '付款',
    cacBuoc: '处理步骤',
  },
  flow: {
    tabThongTin: '订单信息',
    tabChiTiet: '订单明细',
    tabFlow: '订单流程',
    tieuDe: '订单处理流程',
    moRongTatCa: '全部展开',
    thuGonTatCa: '全部收起',
    buocDonMoi: '新订单',
    buocNhat: '拣货',
    buocKiem: '验货',
    buocDongGoi: '打包',
    buocDieuPhoi: '调度',
    buocGiao: '配送',
    ketThucNhat: '拣货完成',
    ketThucKiemTra: '验货完成',
    ketThucDongGoi: '打包完成',
    ketThucDieuPhoi: '调度完成',
    nguoiThucHien: '执行人',
    buocHienTai: '当前步骤',
    ghiChu: '备注',
    tongSoKien: '总件数',
    ghiChuDongHang: '打包备注',
    lichSu: '状态变更历史',
    trangThaiHienTai: '当前状态',
    chuaCoLichSu: '暂无状态变更记录。',
    ghiChuDon: '订单备注',
    nguoiTao: '创建人',
    hanGiaoHang: '交货期限',
    doUuTien: '优先级',
    dienThoaiNhan: '收件人电话',
    doiTacGiaoHang: '配送合作方',
    buocXong: '已完成',
    buocDangLam: '进行中',
    buocChuaToi: '未开始',
    hienTai: '当前',
    tienTrinh: '进度',
  },
  donHang: {
    sapXepTheoCot: '按列排序',
    tongHopSanPham: '商品汇总',
    tongHopSanPhamTitle: '商品汇总列表',
    tongHopSanPhamTom: '{soDon} 单 · {soMa} 个商品 · 数量: {soLuong}',
    tongHopSanPhamTrong: '所选订单没有商品明细',
    sapXep: '排序',
    sapXepTheoMa: '编码',
    sapXepTheoTen: '名称',
    chiaTheoDon: '按订单拆分',
    khongCoThaoTac: '无操作',
    resetTitle: '重置订单',
    khongCoTrangThaiReset: '该订单没有可重置的有效状态',
    donHuy: '已取消订单',
    overrideTitle: '强制订单状态',
    chuyenDoiLienKetTitle: '转移订单流程',
    hoaDonMoiId: '目标发票',
    trangThaiMucTieu: '目标状态',
    warnings: '警告',
    khongCoNguoi: '—',
    daGan: '已分配 {count} 人',
    chuaGan: '未分配',
    ganBuoc: '分配{buoc}',
    assignPicker: '拣货员',
    assignInspector: '验货员',
    assignPacker: '打包员',
    assignDispatcher: '调度员',
    assignShipper: '配送员',
    ganNhanVienTitle: '分配员工（{count} 单）',
    ganNhanVienHint: '为所选订单状态的环节选择员工',
    khacBuoc: '所选订单属于其他环节（{buoc}）— 请取消选择或分开分配',
    inspectorHint: '验货环节无需预先分配 — 点击"开始验货"即自动接手',
    nutNhat: '拣货',
    nutDong: '打包',
    nutGiao: '配送',
    nutDieuPhoi: '调度',
    sapXepMacDinh: '优先级(默认)',
    sapXepNgayDatMoi: '下单日期最新',
    sapXepNgayDatCu: '下单日期最早',
    sapXepTaoMoi: '创建时间最新',
    sapXepTaoCu: '创建时间最早',
    sapXepHanXa: '交付期限最远',
    sapXepHanGan: '交付期限最近',
    xemDayDu: '查看完整详情',
    khongTaiDuocChiTiet: '无法加载订单详情',
    thongTinGiao: '配送信息',
    daChonDon: '已选择:{count}个订单',
    soSanPhamTong: '商品数',
    soLuongSanPhanTong: '商品总数量',
    tongCanNangChon: '总重量',
    tongTheTichChon: '总体积',
    boChon: '取消选择',
    ganDon: '分配订单',
    ghiDe: '覆盖状态',
    chuyenWorkflow: '转移工作流',
    bulkOverrideTitle: '批量覆盖状态',
    bulkOverrideBoQua: '跳过{count}个已交付/已取消订单',
    lyDoOverride: '覆盖原因',
    giaoThanhCongBtn: '标记已交付',
    giaoThatBaiBtn: '标记交付失败',
    overrideHoanTat: '覆盖完成:{ok}/{total}个成功',
    choXuLy: '等待处理',
    thanhCong: '成功',
    thatBai: '失败',
    khongCoDonHopLe: '没有可覆盖的订单',
    transferTitle: '转移订单工作流',
    transferHint:
      '取消源订单的工作流(源订单被取消),并将目标订单转为"新订单"。两单须属于同一分店,目标订单尚未有工作流。',
    transferNguonHint: '此订单的工作流将被取消',
    transferDichHint: '此订单将转为新订单',
    donNguon: '源订单',
    donDich: '目标订单',
    doiVaiTro: '交换源/目标',
    can2Don: '请选择恰好2个订单以转移工作流',
    inPhieu: '打印单据',
    inPhieuGiaoLogo: '配送单(含标识和地址)',
    inPhieuGiaoToiGian: '配送单(精简)',
    inPhieuDongGoiLogo: '打包单(含标识和地址)',
    inPhieuDongGoiToiGian: '打包单(精简)',
    chonMauIn: '选择打印模板',
    nhomCoLogo: '含标识和地址',
    nhomKhongLogo: '不含标识和地址',
    nhomKhac: '其他',
    mauIn: {
      PHIEU_GIAO_HANG_V1: '配送单 V1',
      HOA_DON_BAN_HANG: '销售发票 V1',
      PHIEU_GIAO_HANG_V2: '配送单 V2',
      HOA_DON_BAN_HANG_V2: '销售发票 V2',
      PHIEU_DONG_GOI: '打包单',
    },
    inPhieuDaIn: '打印(已打印 {count} 次)',
    daTaoPhieuIn: '已生成{count}张单据待打印',
    boQuaDonHuy: '跳过{count}个已取消订单',
    xuatExcel: '导出 Excel',
    xuatExcelDon: '导出订单列表 Excel',
    xuatExcelChiTiet: '导出商品明细 Excel',
    xuatExcelThanhCong: '导出 Excel 成功!',
    xuatExcelLoi: '导出 Excel 失败',
    fileExcelDon: '履约订单列表',
    fileExcelChiTiet: '履约订单明细',
    thuKhac: '其他费用',
  },
  thongBao: {
    trungTam: '通知中心',
    danhSach: '通知列表',
    thongBaoChung: '广播通知',
    chuaXemTatCa: '全部标记已读',
    khongCoThongBao: '暂无通知',
    choPhepPush: '在此设备上开启推送',
    pushDaBat: '推送已开启',
    pushBiTuChoi: '浏览器拒绝了通知权限',
    pushLoiCauHinh: '未配置 Firebase（REACT_APP_FIREBASE_*）— 推送已关闭',
    diDenDon: '前往订单',
  },
  in: {
    phieuDongGoi: '打包单',
    phieuGiaoHang: '配送单',
    chiNhanh: '分店',
    khachHang: '客户',
    nguoiBan: '销售员',
    nguoiNhan: '收货人',
    nguoiDongGoi: '打包人',
    nguoiShip: '配送人',
    chiTietHang: '商品明细',
    stt: '序号',
    maHang: '编码',
    tenHang: '名称',
    soLuong: '数量',
    donVi: '单位',
    ghiChu: '备注',
    tongCong: '合计',
    thoiGianIn: '打印时间',
    inLanThu: '第几次打印',
    khachCanTra: '应收金额',
    khachDaTra: '已收金额',
    conLai: '剩余',
    trangThaiThanhToan: '付款',
    qrBanGiao: '扫描交接二维码',
    donVanDon: '运单',
    ketQua: '结果',
  },
  buoc: {
    gan: '分配',
    nhat: '拣货',
    kiem: '检查',
    dong: '打包',
    dieu: '调度',
    giao: '配送',
    giaoLai: '重新配送',
    chiTiet: '详情',
  },
  aria: {
    moMenuThaoTac: '打开操作菜单',
    xemChiTiet: '查看订单详情',
    chonCotHienThi: '选择显示列',
    moMenuSapXep: '打开排序菜单',
    moRongDong: '展开行详情',
    selectAllPage: '全选本页',
    selectRow: '选择行',
  },
  // ===== impl-c =====
  implC: {
    common: {
      xoa: '删除',
      tonKho: '库存',
    },
    xepNhat: {
      nhatDu: '全部拣足',
      datLai: '重置',
      viewerOnly: '此订单正由 {nguoi} 拣货 — 您仅有查看权限。',
      viewerOnlyKhongTen: '此订单已分配给其他拣货员 — 您仅有查看权限。',
      daDuToanBo: '所有行均已拣足',
      daVeKhongToanBo: '拣货数量已为 0',
    },
    kiemTra: {
      kiemDu: '全部检查',
    },
    chiTietDon: {
      tabSanPham: '商品',
      daKiem: '已检查',
      kgThung: '公斤/箱',
      m3Thung: '立方米/箱',
      slThung: '数量/箱',
      soThung: '箱数',
      kichThuoc: '长×宽×高',
      viTri: '库位',
      tongCanNang: '总重量（公斤）',
      tongTheTich: '总体积',
      mocCaoNhat: '流程最高节点',
      trangThaiHienTai: '当前状态',
      sheetName: '订单商品明细',
      filePrefix: '订单商品明细',
    },
    tongHopSp: {
      tieuDe: '商品汇总列表',
      thongKe: '{soDon} 个订单 · {soMa} 个商品编码 · 数量：{soLuong}',
      sapXep: '排序',
      ma: '编码',
      ten: '名称',
      chiaDon: '按订单拆分',
      dangTai: '正在汇总商品…',
      khongCoDuLieu: '所选订单没有商品明细。',
    },
    gallery: {
      xem: '查看（{so} 张图片）',
      moTabMoi: '在新标签页打开图片',
      truoc: '上一张',
      sau: '下一张',
    },
    kien: {
      tabThongTin: '信息',
      tabInPhieu: '打印单据',
      danhSachKien: '包裹列表',
      tong: '共 {so} 件',
      chan: '整箱',
      le: '散件',
      gop: '混装',
      soKienVatLy: '件数',
      loai: '类型',
      sanPham: '商品',
      soLuongKien: '重复件数',
      taoGop: '创建混装箱',
      goiYCoBan: '基础建议',
      goiYThongMinh: '智能建议',
      inA4: '打印 A4 单据',
      inA5: '打印 A5 单据',
      taoGopTieuDe: '创建混装箱',
      daChon: '已选择 {chon}/{tong} 个商品',
      slCo: '可用数量',
      khongConSpGop: '没有可合并的商品',
      taoGopThanhCong: '创建混装箱成功！',
      can2Sp: '混装箱至少需要 2 个商品！',
      loiSl: '数量超过可用数量：',
      loiSlChiTiet: '{ten}：要求 {yeucau}，但只有 {co} 可用',
      daLuu: '已保存包裹',
      xemTabInPhieu: '在"打印单据"标签页查看/修改',
      phieuKien: '包裹单',
      phieuKienGop: '混装包裹单',
      kien: '件',
      ngay: '日期',
      gio: '时间',
      chuKy: '打包人签名',
      maDon: '订单编号',
      daTaoTrang: '已生成 {so} 页单据待打印（{khogiay}）！',
      chuaCoKien: '暂无包裹 — 点击"基础建议"生成',
    },
    g18: {
      chuaCoPhieu: '订单还没有{buoc}记录',
      xemPhieuDongGoi: '打包单',
      xemPhieuDieuPhoi: '调度单',
      xemDonShip: '配送单',
      bulkGiao: '配送',
      bulkDieuPhoi: '调度多个订单',
    },
    g19: {
      tabThongTinDon: '订单信息',
      tabFlowDon: '订单流程',
      thongTinCoBan: '基本信息',
      nguoiTao: '创建人',
      buocDonMoi: '新订单',
      moTa: '描述',
      trangThaiCaoNhat: '订单达到过的最高状态',
      lichSuThayDoi: '状态变更历史',
      moRongTatCa: '全部展开',
      thuGonTatCa: '全部收起',
      moRong: '展开',
      thuGon: '收起',
      anh: '图片',
      ghiChuSp: '商品备注',
      chuaCo: '暂无',
      khongCoGhiChu: '暂无备注',
    },
  },
  // ===== impl-a =====
  implA: {
    ganTuanTuHint: '所选订单状态相同。系统逐单处理 — 无需切换工作分店。',
    logDangXuLy: '… {ma}：处理中',
    logOk: '✓ {ma}：完成',
    logLoi: '✗ {ma}：{msg}',
    loiChung: '错误',
    ketQuaHonHop: '成功 {ok} 单，失败 {fail} 单：{loi}',
    thatBaiHet: '没有订单处理成功 — 请查看下方日志',
    dangGan: '正在分派…',
    dieuPhoiNhieuDon: '批量调度',
    dieuPhoiNhieuDonTitle: '调度多笔订单（{count} 单）',
    dieuPhoiAutoChainHint: '每笔待调度 / 调度中订单：加入 → 开始 → 完成（含配送员）。不符合条件的订单将被跳过。',
    dieuPhoiBoQua: '已跳过 {count} 笔非待调度 / 调度中的订单',
    dieuPhoiKhongHopLe: '没有符合条件的订单（待调度 / 调度中）',
    nguoiGiaoLabel: '配送员',
    ghiChuDieuPhoi: '调度备注（完成时应用）',
    batDauDieuPhoi: '开始调度',
    dangDieuPhoi: '正在调度…',
    dieuPhoiKetQua: '已调度 {ok}/{total} 单，{fail} 失败',
    giaoNhieuDon: '批量配送',
    giaoNhieuDonTitle: '批量配送（{count} 单）',
    giaoAutoChainHint: '每笔订单：加入配送记录（如需）→ 开始配送 → 按所选结果完成。照片和备注适用于所有已选订单。',
    giaoBoQua: '已跳过 {count} 笔不符合条件的订单（无配送记录或状态不适合）',
    giaoKhongHopLe: '没有符合条件的订单（缺少配送记录或状态不适合）',
    giaoHoanThanh: '配送完成',
    giaoMotPhan: '部分配送',
    giaoThatBai: '失败',
    ghiChuGiaoMotPhan: '部分配送备注',
    ghiChuGiaoThanhCong: '配送成功备注',
    ghiChuGiaoThatBai: '失败原因 / 备注',
    anhGiaoChung: '配送照片（选择一次 — 每笔订单分别上传）',
    canLyDoGiaoThatBai: '需要填写失败原因',
    thucHien: '执行',
    dangGiao: '正在配送…',
    giaoKetQua: '已处理 {ok}/{total} 单，{fail} 失败',
    tuyChon: '可选',
    xuatExcelCotHienThi: '导出 Excel（当前显示列）',
    soLanInHint: '已打印 {count} 次',
    lichSuTrangThai: '状态历史',
    chuaCoLichSu: '暂无状态历史',
    trangThaiCaoNhatNguon: '源订单曾达到的最高状态',
    dichSeVaoMoi: '目标订单将进入"新（MOI）"状态',
    assignScopeTatCa: '全部',
    assignScopeChiToi: '仅我的',
    assignScopeHint: '按当前持有步骤的人员筛选订单',
    assignScopeAria: '人员范围',
    tongHopSp: '汇总商品',
    nhomHang: '商品组',
    thoiGianTheoBuoc: '各环节时间',
    buocNhat: '拣货',
    buocKiemTra: '验货',
    buocDongGoi: '打包',
    buocDieuPhoi: '调度',
    buocGiaoHang: '配送',
    tu: '从',
    den: '至',
    chiTietNhat: '拣货详情',
    chuaCoPhanCongNhat: '订单尚无拣货分配 — 请先创建分配',
    chiTietKiemTra: '验货详情',
    chuaCoPhieuKiemTra: '订单尚无验货单（拣货完成后自动创建）',
  },
  // ===== be-vanhanh =====
  beVanHanh: {
    dieuPhoiView: {
      densityLabel: '行密度',
      densityDefault: '常规',
      densityCompact: '紧凑',
      densityUltra: '超紧凑',
      tableViewLabel: '表格布局',
      singleTable: '单表',
      splitTable: '分屏',
      zoomOut: '缩小',
      zoomIn: '放大',
      zoomReset: '恢复默认缩放（100%）',
      fullscreen: '全屏',
      fullscreenClose: '关闭',
      reset: '默认',
      resetHint: '重置密度、缩放和布局为默认',
    },
  },
}
